import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path
    id="Subtract"
    fillRule="evenodd"
    clipRule="evenodd"
    d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.3529 7.17647C13.3529 7.82622 12.8262 8.35294 12.1765 8.35294C11.5267 8.35294 11 7.82622 11 7.17647C11 6.52672 11.5267 6 12.1765 6C12.8262 6 13.3529 6.52672 13.3529 7.17647ZM12.1763 9.70605C12.7286 9.70605 13.1763 10.1538 13.1763 10.7061V16.0002C13.1763 16.5525 12.7286 17.0002 12.1763 17.0002C11.624 17.0002 11.1763 16.5525 11.1763 16.0002V10.7061C11.1763 10.1538 11.624 9.70605 12.1763 9.70605Z"
    fill="currentColor"
  />,
  'SemanticInformation'
)
